import { CartContainer } from "./style";
import { useSelector } from "react-redux";
import Warning from "../../assets/zkp/warning.svg";
import imgVinho from "../../assets/zkp/img-vinho.png";

export function CardProductCart() {
  const data = useSelector((state) => state.cartSlice.data);

  const totalCart = data.reduce((acc, product) => {
    return acc + product.price * product.quantity;
  }, 0);

  const countCart = data.reduce((acc, product) => {
    return acc + product.quantity;
  }, 0);

  return (
    <CartContainer>
      <ul>
        <li className="textHead">
          <span>Produto</span>
          <span>Quantidade</span>
          <span>Preço</span>
        </li>
      </ul>
      {data.map(({ id, name, price, img, quantity, productCode }) => (
        <ul key={id}>
          <li className="containerCart">
            <div className="containerImg">
              <img
                src={process.env.REACT_APP_ZKP === "true" ? imgVinho : img}
                alt=""
              />
              <section className="descriptionProduct">
                <h3>{name}</h3>
                <p>{productCode}</p>
                {process.env.REACT_APP_ZKP && (
                  <div className="zkp">
                    <img src={Warning} alt="" />
                    <p>
                      Produto vendido para maiores de 18 anos. <br /> Sua idade
                      será validada ao finalizar a compra.
                    </p>
                  </div>
                )}
                <div>
                  <button>Excluir</button>
                  <span>|</span>
                  <button>Salvar para mais tarde</button>
                </div>
              </section>
            </div>
            <div className="amount">
              <button>-</button>
              <span>{quantity}</span>
              <button>+</button>
            </div>
            <span>
              {price.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })}
            </span>
          </li>
        </ul>
      ))}
      <p className="subtotal">
        Subtotal({countCart} Itens):{" "}
        {totalCart.toLocaleString("pt-br", {
          style: "currency",
          currency: "BRL",
        })}
      </p>
    </CartContainer>
  );
}
